import { render, staticRenderFns } from "./btn-secondary3.vue?vue&type=template&id=60f9143a&scoped=true&"
import script from "./btn-secondary3.vue?vue&type=script&lang=js&"
export * from "./btn-secondary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9143a",
  null
  
)

export default component.exports